export class JobsRoutesHelper {
    public static jobsUrlPrefix = 'recruiting/jobs';
    public static facilityDetailsUrlPrefix = 'recruiting/facilities/';

    public static getJobsGridUrl(): string {
        return this.jobsUrlPrefix;
    }

    public static getFacilityDetailsUrl(id: number): string {
        return `${this.facilityDetailsUrlPrefix}${id}`;
    }

    public static getUnitLink(unitFormId: number | string, contactId: number, ayacDomain: string) {
        if (ayacDomain.indexOf('http') <= 0) {
            ayacDomain = '//' + ayacDomain;
        }

        if (!ayacDomain.endsWith('/')) {
            ayacDomain = ayacDomain + '/';
        }

        return `${ayacDomain}#/units?userId=${contactId}&formId=${unitFormId}&preview=true`;
    }
}
